module.exports = __webpack_public_path__ + "assets/d36a34410b0d7fe6b603eca0b7295bb9.svg";